// import promise from 'es6-promise'
// import 'babel-polyfill'
// promise.polyfill() // 兼容 Promise

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'core-js/stable';
import 'regenerator-runtime/runtime'; // 如果你使用了 async/await 等特性
import '@/css/common.scss'
import Vant from 'vant'
import 'vant/lib/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import GTM from './utils/GTM'
import { gethlSignature, gethlSignature1 } from './api/index'
import {
    wxShares
} from "./utils/wxShare"
import {
    IEVersion
} from "./utils/common"
import BaiduMap from 'vue-baidu-map'
import moment from 'moment'
Vue.prototype.$moment = moment

Vue.prototype.$eventBus = new Vue();

// Vue.use(GTM)
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'SS6GGvZfEfqF0TbOWjR6N2niD7Yg8Vx0'
})

Vue.config.productionTip = false

Vue.use(Vant)
Vue.use(ElementUI)

window.dataLayer = window.dataLayer || [];
Vue.directive('ga', {
    componentUpdated: function(el, binding, vnode) {
        el.addEventListener('click', (e) => {
            // console.log(binding.value)
            var ga_Code = JSON.parse(JSON.stringify(binding.value));
            // console.log(dataLayer)
            dataLayer.push(ga_Code);
            // console.log(dataLayer)
        }, false);
    }
});

// 引入jquery
// import $ from 'jquery'
// Vue.prototype.$ = $;   // 当然还有这句话 给vue原型上添加 $ 

// 方法2 是否是移动端
// let isMobil = false
// if (document.body.clientWidth <= 828) {
//   isMobil = true
// }
// Vue.prototype.isMobil = isMobil

// 是否是ie
// Vue.prototype.isIe = IEVersion()

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')

// const ShareConfig = {
//   title: '',
//   desc: '',
//   imgUrl: '', // 分享的小图标
//   link: '', // 分享的除去的url
// }


// gethlSignature().then(res => {
//   wxShares(res, ShareConfig)
// })
// gethlSignature1().then(res => {
//   wxShares(res, ShareConfig)
// })